import { ThreeItemKeys, ThreeItemTypes } from '../../../constants/three'
import { getObjectsByUserData } from '../../../helpers/scene-json'
import { createQuery } from '@tanstack/svelte-query'
import { get } from 'svelte/store'
import { storeScene } from '../../../stores/scene'
import queryClient from '../../../constants/query-client'

const useFilesQueries = () => {
  const getFiles = () => {
    const scene = get(storeScene)

    return getObjectsByUserData(scene, ThreeItemKeys.ITEM_TYPE, ThreeItemTypes.FILE)
  }

  const useFiles = () => createQuery(() => ({
    queryKey: ['canvas', 'files'],
    queryFn: getFiles,
  }), () => queryClient)

  return {
    useFiles,
  }
}

export default useFilesQueries
